module.exports = __webpack_public_path__ + "static/media/collage_4.550749bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/collageGame/collage_4.jpg
// module id = 2258
// module chunks = 0